// Every Microsoft-managed baseline Conditional Access policy carries this
// exact prefix — trimming it for display is a formatting choice, not a
// translation: the rest of the name (and the real policy it identifies)
// stays untouched. Never use the trimmed result for pageLabel/note
// matching — those have to stay keyed on the real, full displayName.
export function displayCaPolicyName(displayName) {
  if (!displayName) return displayName;
  return displayName.replace(/^Microsoft-managed:\s*/i, '') || displayName;
}
